// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1WinL","consentsList":"PatientConsents_consentsList__1oRTp","consentsListEmpty":"PatientConsents_consentsListEmpty__25XAs"};